import Component from '@glimmer/component';

import { concat } from '@ember/helper';
import LinksTo from 'ember-route-state/components/links-to.gjs';

import classMod from 'rise-ui/helpers/class-mod.js';
import fnx from 'rise-ui/helpers/fnx.js';

export default class SearchButtonComponent extends Component {
  get label() {
    return this.args.searchLabel || 'Search';
  }

  <template>
    <LinksTo
      @route={{@route}}
      title={{concat
        this.label
        (if @refresh " (Refresh)")
        (if @loading " (Loading)")
      }}
      class={{classMod "c-search-button qa-search-button"
        @loading "--loading"
        @refresh "--refresh"
      }}
      @onLink={{fnx @onLink}}
      ...attributes
    >{{this.label}}</LinksTo>
  </template>
}
